import { Controller, useFormContext } from 'react-hook-form'

import { FormFieldProps } from '../Form/typings.js'

import {
  FormControlHtmlEditor,
  FormControlHtmlEditorProps,
} from './FormControlHtmlEditor.js'

export function SimpleHtmlEditor({
  name,
  validation,
  value: fieldValue,
  onChange: selectOnChange,
  ...rest
}: FormFieldProps<FormControlHtmlEditorProps>) {
  const { control } = useFormContext()

  return (
    <Controller
      control={control}
      name={name}
      rules={validation}
      render={({ field: { onChange, value, ref }, fieldState: { error } }) => (
        <FormControlHtmlEditor
          {...rest}
          name={name}
          invalid={!!error?.message}
          error={error?.message}
          inputRef={ref}
          onChange={value => {
            onChange(value)
            if (typeof selectOnChange === 'function') {
              selectOnChange(value)
            }
          }}
          value={fieldValue ?? value}
        />
      )}
    />
  )
}
